import { SideChatControl } from "components/SideChatControl/SideChatControl";
import { ACTIVITY_TAB, CHAT_TAB, ChatTabType } from "constants/chatTab";
import ToolTip from "components/design/toolTip";
import { Button } from "components/DesignSystem/Button/Button";
import { Switch } from "components/DesignSystem/Switch/Switch";
import Tab from "components/DesignSystem/Tab/Tab";
import { ExpandNavIcon } from "components/icons/ExpandNavIcon";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { ShowControl } from "hooks/useShow";
import React from "react";
import PrivateChatHeaderIcon from "static/images/PrivateChatHeaderLock.svg";

type ChannelHeaderWithOnlySwitchProps = {
  isPrivateChannel: boolean;
  setPrivateChannel: () => void;
  channelId?: string | null;
  activeTab?: ChatTabType;
  setActiveTab?: (tab: ChatTabType) => void;
} & (
  | { hidable: true; hideControl: ShowControl }
  | { hidable?: false; hideControl?: ShowControl }
);

export const ChannelHeaderWithOnlySwitch = ({
  isPrivateChannel,
  setPrivateChannel,
  hideControl,
  hidable = false,
  channelId,
  activeTab = CHAT_TAB,
  setActiveTab,
}: ChannelHeaderWithOnlySwitchProps) => {
  const { isCustomer } = useRoleBasedView();

  return (
    <>
      <div className="t-flex t-bg-white t-px-4 t-pt-1.5 t-justify-between t-items-end t-border-0 t-border-b t-border-solid t-border-neutral-10">
        <div className="t-flex t-items-center t-gap-4">
          {setActiveTab ? (
            <Tab.Root
              value={activeTab}
              onValueChange={(value) => setActiveTab(value as ChatTabType)}
            >
              <Tab.List className="!t-gap-4 !t-p-0 !t-mb-0 !t-border-b-0">
                <Tab.Trigger value={CHAT_TAB}>Chat</Tab.Trigger>
                <Tab.Trigger value={ACTIVITY_TAB}>Activity</Tab.Trigger>
              </Tab.List>
            </Tab.Root>
          ) : (
            <div className="t-text-subtitle t-text-text-100 t-pb-2">Chat</div>
          )}
          {!isCustomer && (
            <div className="t-flex t-pb-2">
              <Switch
                checked={isPrivateChannel}
                onCheckedChange={setPrivateChannel}
                size="small"
              />
            </div>
          )}
        </div>
        {hidable && hideControl && (
          <div className="t-pb-1 t-pt-0.5">
            <ToolTip
              text={hideControl.shown ? "Hide Chat" : "Show Chat"}
              side="bottom"
            >
              <Button
                customType="ghost_icon"
                size="small"
                onClick={hideControl.toggle}
              >
                <ExpandNavIcon className="t-text-text-30" />
              </Button>
            </ToolTip>
          </div>
        )}
      </div>
      {isPrivateChannel && (
        <div className="t-flex t-items-center t-justify-center t-bg-dark_green-30 t-p-1.5">
          <img
            className="t-h-3.5"
            src={PrivateChatHeaderIcon}
            alt="private chat icon"
          />
          <span className="t-text-subtext-sm t-font-semibold t-text-dark_green-90">
            &nbsp; This is a private chat
          </span>
        </div>
      )}
    </>
  );
};
